module.exports = __webpack_public_path__ + "img/la_podcast.b5da25df.svg";